const SAVE_PAGINATION_TOTAL = 'SAVE_PAGINATION_TOTAL';

export const getPaginationTotal = key => state => {
	return state.pagination[key];
};

export const savePaginationTotal = (key, total) => ({
	type: SAVE_PAGINATION_TOTAL,
	total,
	key,
});

export default function reducer(action = {}, state = {}) {
	if (action.type === SAVE_PAGINATION_TOTAL) {
		return {
			...state,
			[action.key]: action.total,
		};
	} else {
		return state;
	}
}



// WEBPACK FOOTER //
// ./src/data/store/pagination.js